import React, { Component } from "react";

import { MaterialText } from "components/presentation/material-text";

import { MfaVerify } from "../mfa-verify";
import { MfaNumber } from "../mfa-number";
import { MFA_AUTHENTICATION_TYPES } from "constants/multi-factor-authentication";
import { MESSAGE_IDS } from "constants/message-ids";

class MfaAppEnabled extends Component {
    state = {};

    displayLineTitle() {
        const { classes, title } = this.props;

        return (
            <div className={classes.line}>
                <MaterialText>{title}</MaterialText>
            </div>
        );
    }

    displayLineOne() {
        const { userId, orgId, onVerify, classes, rememberMeDays, messages } =
            this.props;
        const verifyProps = {
            userId,
            orgId,
            onVerify,
            enabled: true,
            mfaOption: MFA_AUTHENTICATION_TYPES.APP,
            rememberMeDays,
            messages,
        };

        return (
            <div className={classes.line}>
                <div className={classes.number}>
                    <MfaNumber number={1} />
                </div>
                <div>
                    <MaterialText>
                        {messages[MESSAGE_IDS.MFA.APP_ENABLED]}
                    </MaterialText>
                    <div className={classes.verify}>
                        <MfaVerify {...verifyProps} />
                    </div>
                </div>
            </div>
        );
    }

    render() {
        return (
            <div>
                {this.displayLineTitle()}
                <div>{this.displayLineOne()}</div>
            </div>
        );
    }
}

export { MfaAppEnabled };
